import { InspectionReportDetail, InspectionReportsResponse } from '../types'
import { InspectionReportsActions, inspectionReportsTypes } from './types'

const inspectionReportsActions = {
  fetchInspectionReports: (
    payload: {
      limit: number,
      page: number,
      start: number,
    },
    callback?: (succ: boolean) => void
  ): InspectionReportsActions => ({
    type: inspectionReportsTypes.FETCH_INSPECTION_REPORTS,
    payload,
    callback,
  }),
  setInspectionReports: (
    payload: InspectionReportsResponse | null
  ): InspectionReportsActions => ({
    type: inspectionReportsTypes.SET_INSPECTION_REPORTS,
    payload,
  }),
  fetchInspectionReportById: (
    payload: string,
    callback?: (succ: boolean) => void
  ): InspectionReportsActions => ({
    type: inspectionReportsTypes.FETCH_INSPECTION_REPORT_BY_ID,
    payload,
    callback,
  }),
  setInspectionReportById: (
    payload: InspectionReportDetail | null
  ): InspectionReportsActions => ({
    type: inspectionReportsTypes.SET_INSPECTION_REPORT_BY_ID,
    payload,
  }),
  createInspectionReport: (
    payload: {
      estimateId: string,
      fileUrl: string,
    },
    callback?: (succ: boolean) => void
  ): InspectionReportsActions => ({
    type: inspectionReportsTypes.CREATE_INSPECTION_REPORT,
    payload,
    callback,
  }),
}

export default inspectionReportsActions
